import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import Logo from "Images/shop/gainful_square_logo.svg";
import styles from "./styles.module.scss";
import React from "react";
const tickerItems = ["Clean Ingredients", "No Fillers"];
const PLPTicker = () => {
    const multiplier = Math.floor(useScreenWidth() / 880) + 1;
    const resultArray = Array.from({ length: multiplier }, () => [...tickerItems]).flat();
    return (_jsx("div", { className: styles.tickerWrapper, children: _jsx("div", { className: cx(styles.ticker, styles.marquee), children: _jsx("ul", { className: styles.marquee__content, children: resultArray.map((item, i) => {
                    return (_jsxs(React.Fragment, { children: [_jsx("li", { children: _jsx("img", { src: Logo, alt: "Gainful Logo", width: 15, height: 15 }, "flavors") }, i + "content-1"), _jsx("li", { className: styles.tickerItem, children: item }, i)] }, item + i));
                }) }) }) }));
};
export default PLPTicker;
